import { LitEntity, html, SirenActionMixin } from '../utility/lit-entity';
import { IndexMixin } from '../utility/index-mixin';
import { StoreMixin } from '../utility/store-mixin';
import './work-order-admin-list';
import './work-order-admin-show';

class WorkOrderAdminIndex extends StoreMixin(IndexMixin(SirenActionMixin(LitEntity))) {
  static get properties() {
    return {
      workOrderId: { type: String, attribute: false },
    };
  }

  getViews() {
    return [
      {
        default: true,
        name: 'list',
        render: () => html`<work-order-admin-list .href=${this.getHref('https://api.binsentry.com/rel/work-orders')}></work-order-admin-list>`,
      },
      {
        name: 'show',
        render: () => html`<work-order-admin-show .href="${this.workOrderId}"></work-order-admin-show>`,
      },
    ];
  }

  _stateChanged({ query }) {
    this.workOrderId = query?.workOrderId;
  }
}

customElements.define('work-order-admin-index', WorkOrderAdminIndex);
